import { useEffect } from "react";
import { useAuthdAPI } from "../../../../utils/api";
import { useErrorToast } from "../../../../utils/showToast";

export function useInServer() {
  const { data: inServer, error: isInServerError } = useAuthdAPI<
    boolean | null
  >("discord/in-server");
  const showErrorToast = useErrorToast();
  const isLoading = inServer === undefined && isInServerError === undefined;

  // Display error toast if there is an error
  useEffect(() => {
    if (isInServerError) {
      showErrorToast(isInServerError);
    }
  }, [isInServerError, showErrorToast]);

  return { inServer, isLoading };
}
